package org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card


import org.hs_soft.runmynesto.domain.util.getEndOfMonth
import org.hs_soft.runmynesto.domain.util.getStartOfMonth
import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class PeriodMonthEnum(
    val from: String,
    val to: String
) {
    January(
        from = getStartOfMonth(1),
        to = getEndOfMonth(1)
    ),
    February(
        from = getStartOfMonth(2),
        to = getEndOfMonth(2)
    ),
    March(
        from = getStartOfMonth(3),
        to = getEndOfMonth(3)
    ),
    April(
        from = getStartOfMonth(4),
        to = getEndOfMonth(4)
    ),
    May(
        from = getStartOfMonth(5),
        to = getEndOfMonth(5)
    ),
    June(
        from = getStartOfMonth(6),
        to = getEndOfMonth(6)
    ),
    July(
        from = getStartOfMonth(7),
        to = getEndOfMonth(7)
    ),
    August(
        from = getStartOfMonth(8),
        to = getEndOfMonth(8)
    ),
    September(
        from = getStartOfMonth(9),
        to = getEndOfMonth(9)
    ),
    October(
        from = getStartOfMonth(10),
        to = getEndOfMonth(10)
    ),
    November(
        from = getStartOfMonth(11),
        to = getEndOfMonth(11)
    ),
    December(
        from = getStartOfMonth(12),
        to = getEndOfMonth(12)
    );

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            January -> strings.January
            February -> strings.February
            March -> strings.March
            April -> strings.April
            May -> strings.May
            June -> strings.June
            July -> strings.July
            August -> strings.August
            September -> strings.September
            October -> strings.October
            November -> strings.November
            December -> strings.December
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                January -> strings.January
                February -> strings.February
                March -> strings.March
                April -> strings.April
                May -> strings.May
                June -> strings.June
                July -> strings.July
                August -> strings.August
                September -> strings.September
                October -> strings.October
                November -> strings.November
                December -> strings.December
            }
        }
}